export const CONNECTION_TYPES = Object.freeze({
  API: 'api',
  RPA: 'rpa',
  AGREEMENT: 'agreement',
});